import * as $ from 'jquery';

export default class Utils {
    static convertObjToUrlParams(data) {
        return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
    }

    static handleErrorWithNotification(errorObj, noty) {
        if(typeof errorObj === 'string' && errorObj.length > 0) {
            noty.error(errorObj);
        } else {
            if(errorObj.message != null) {
                noty.error(errorObj.message);
            } else if(errorObj.errors != null) {
                for(let err of errorObj.errors) {
                    noty.error(err.message);
                }
            } else {
                // noty.error('متاسفانه خطایی سیستمی رخ داد.');
            }
        }
    }

    static objectsHaveSameKeys(...objects) {
        const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
        const union = new Set(allKeys);
        return objects.every(object => union.size === Object.keys(object).length);
    }

    static resetObject(object) {
        for (let item in object) {
            if (typeof object[item] === 'number') {
                object[item] = 0;
            } else if (typeof object[item] === 'boolean') {
                object[item] = false;
            } else if (typeof object[item] === 'object') {
                this.resetObject(object[item]);
            } else {
                object[item] = "";
            }
        }
        return object;
    }

    static onBottomReached() {
        let docHeight = $(document).height();
        let winHeight = $(window).height();
        if (($(window).scrollTop() + winHeight) === (docHeight)) {
            return 1;
        }
        return 0;
    }
}